module.exports = __webpack_public_path__ + "static/TP-d317d9aee69fb3c883355c38426fe2fc.png";